module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-icon', {
    staticStyle: {
      "font-size": "40px",
      "float": "left",
      "vertical-align": "middle",
      "margin-right": "10px"
    }
  }, [_vm._v("fingerprint")]), _vm._v(" "), _c('div', {
    staticClass: "heading",
    staticStyle: {
      "margin": "5px 0px 15px 0px"
    }
  }, [_vm._v("Welcome to Taco")]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticStyle: {
      "color": "grey",
      "font-size": "12px"
    }
  }, [_vm._v("You are signed in as " + _vm._s(_vm.user.email) + " \n    "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign Out")])]) : _vm._e(), _vm._v(" "), _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n    Join " + _vm._s(_vm.officeName || ' an Office') + "\n    "), _c('small', [_vm._v("Enter credentials to join.")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Invite Code"
    },
    on: {
      "change": _vm.updateOfficeName
    },
    model: {
      value: (_vm.inviteCode),
      callback: function($$v) {
        _vm.inviteCode = $$v
      },
      expression: "inviteCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "type": "password",
      "label": "Pin Number"
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.joinOffice($event)
      }
    }
  }, [_vm._v("Join")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Create your profile")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "First Name",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Last Name",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Email",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Mobile"
    },
    model: {
      value: (_vm.user.mobile),
      callback: function($$v) {
        _vm.$set(_vm.user, "mobile", $$v)
      },
      expression: "user.mobile"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    nativeOn: {
      "click": function($event) {
        return _vm.createProfile($event)
      }
    }
  }, [_vm._v("Create")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3
    }
  }, [_vm._v("Start using Taco")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("\n            Gracias. You are ready to begin. To find out more about Taco, "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.google.com/search?q=taco"
    }
  }, [_vm._v("click here")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_vm._v("Start Using Taco")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000
    },
    model: {
      value: (_vm.snackbarShow),
      callback: function($$v) {
        _vm.snackbarShow = $$v
      },
      expression: "snackbarShow"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar) + "\n    "), _c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("fingerprint")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5232021a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Join.vue
// module id = 2547
// module chunks = 1